export { default as VendorIcon } from './ic_vendor_reward.svg';
